import { createContext, FC, ReactNode, useContext, useState } from 'react'
import { createPortal } from 'react-dom'

import { Dropdown as BsDropdown, Spinner } from 'react-bootstrap'
import { IconSize, KTSVG } from '_metronic/helpers'

const DropdownCloseContext = createContext<() => void>(() => {})

/** Permite a um item dentro do Dropdown fechá-lo manualmente (ex.: antes de abrir um modal). */
export const useDropdownClose = () => useContext(DropdownCloseContext)

type IDropdown = {
  children: ReactNode
  name?: string
  isBottom?: boolean
  size?: number
  onOpen?: () => void | Promise<void>
  isLoading?: boolean
  icon?: string
  /** Classes extras aplicadas ao menu, para sobrescrever o padding/borda padrão do Bootstrap */
  menuClassName?: string

  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | 'transparent'
}

export const Dropdown: FC<IDropdown> = ({
  children,
  name = 'Ações',
  isBottom = true,
  size = 125,
  onOpen,
  isLoading,
  icon,
  menuClassName,
  variant = 'secondary',
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = (nextOpen: boolean) => {
    setIsOpen(nextOpen)

    if (nextOpen) {
      onOpen?.()
    }
  }

  return (
    <BsDropdown drop={isBottom ? 'down' : 'up'} show={isOpen} onToggle={handleToggle}>
      <BsDropdown.Toggle
        variant={variant}
        size='sm'
        bsPrefix={icon ? 'btn' : undefined}
        className={`${
          icon ? 'p-0' : 'btn-active-secondary-primary'
        } d-inline-flex align-items-center justify-content-center gap-1
  `}
      >
        {icon ? <KTSVG path={icon} size={IconSize.Small} /> : <span>{name}</span>}
      </BsDropdown.Toggle>

      {isOpen &&
        createPortal(
          <BsDropdown.Menu
            align='end'
            className={menuClassName ?? 'py-4'}
            style={{ width: `${size}px`, position: 'absolute', zIndex: 2000 }}
          >
            <DropdownCloseContext.Provider value={() => setIsOpen(false)}>
              {isLoading ? (
                <div className='text-center py-3'>
                  <Spinner size='sm' animation='border' />{' '}
                  <span className='ms-2'>Carregando...</span>
                </div>
              ) : (
                <>{children}</>
              )}
            </DropdownCloseContext.Provider>
          </BsDropdown.Menu>,
          document.body
        )}
    </BsDropdown>
  )
}
